import { Box } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { ReactNode } from "react";
import { ControllerFieldState } from "react-hook-form";
import { FieldRuntimeProps } from "../types/record-producer-types";
import { useTranslation } from "react-i18next";

const TranslatedFieldErrorMessage = ({ message }: { message: string }) => {
    const { t } = useTranslation();

    return <>{t(message)}</>;
};

export const getFieldHelperText = (
    fieldState: ControllerFieldState,
    runtimeProps?: FieldRuntimeProps
): ReactNode => {
    if (fieldState.error?.message) {
        return (
            <Box component="span" sx={{ display: "inline-flex", alignItems: "flex-start", gap: 0.5 }}>
                <ErrorOutlineIcon color="error" sx={{ fontSize: "1rem", flex: "0 0 auto" }} />
                <Box component="span">
                    <TranslatedFieldErrorMessage message={fieldState.error.message} />
                </Box>
            </Box>
        );
    }

    if (!runtimeProps?.helperText) {
        return undefined;
    }

    return (
        <Box component="span" sx={{ display: "inline-flex", alignItems: "flex-start", gap: 0.5 }}>
            <InfoOutlinedIcon color="info" sx={{ fontSize: "1rem", flex: "0 0 auto" }} />
            <Box component="span">{runtimeProps.helperText}</Box>
        </Box>
    );
};
